<template>
<v-fade-transition>
    <div class="page_loader" v-if="!isLoaded">
        <div>
            <img class="mb-5" src="@/assets/bns.svg" width="300px"/>
            <v-progress-linear
                color="#920825"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
        </div>
        
    </div>
    </v-fade-transition>
</template>
<script>
export default {
    data(){
        return {
            isLoaded: false,
            intervalId: null
        }
    },
    mounted(){
        this.intervalId = setInterval(() => {
            if(document.readyState == "complete"){
                this.isLoaded = true;
                clearInterval(this.intervalId);
            }
        }, 2000)
    }
}
</script>

<style scoped>
    .page_loader{
        background-color: white;
        justify-content: center;
        display: flex;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 999;
    }
    img {
        width: 200px;
    }
    .v-progress-linear {
        width: 200px;
    }
</style>